module.exports = __webpack_public_path__ + "img/card.53977b7d.png";